import { render, staticRenderFns } from "./iframes.vue?vue&type=template&id=0afdf3f6&"
import script from "./iframes.vue?vue&type=script&lang=js&"
export * from "./iframes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports